require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./the-emperor-has-no-clothes.json") })
        }
      }, "path---the-emperor-has-no-clothes");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---the-emperor-has-no-clothes!./.cache/json/the-emperor-has-no-clothes.json
// module id = 440
// module chunks = 231608221292675